import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 12.5304 13.7893 13.0391 13.4142 13.4142C13.0391 13.7893 12.5304 14 12 14Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "Dot01Xs"
);
